import { rgbFloatsToHex } from "../lib/color";
import { ColorOut } from "../types";
import { ColorSwatchButton } from "./ColorSheet";

interface Props {
  label: string;
  value: string | null; // hex string, e.g. "#e63946"
  presets: ColorOut[];
  onChange: (hex: string) => void;
  onClear?: () => void; // omit to make the color required (e.g. main text color)
}

export function ColorPickerRow({ label, value, presets, onChange, onClear }: Props) {
  const currentHex = value ?? (presets[0] ? rgbFloatsToHex(presets[0].rgb) : "#000000");

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm text-tg-hint">{label}</label>
        {onClear && value && (
          <button type="button" onClick={onClear} className="text-xs text-tg-link">
            إزالة
          </button>
        )}
      </div>

      <div className="flex items-center gap-3">
        <ColorSwatchButton value={currentHex} onChange={onChange} title={label} />

        <div className="flex flex-wrap gap-2">
          {presets.map((p) => {
            const hex = rgbFloatsToHex(p.rgb);
            const isActive = value?.toLowerCase() === hex.toLowerCase();
            return (
              <button
                key={p.key}
                type="button"
                title={p.name}
                onClick={() => onChange(hex)}
                className={`w-7 h-7 rounded-full border-2 ${
                  isActive ? "border-tg-button" : "border-transparent"
                }`}
                style={{ backgroundColor: hex }}
                aria-label={p.name}
              />
            );
          })}
        </div>
      </div>

      <p className="text-tg-hint text-xs mt-1 uppercase" dir="ltr">
        {currentHex}
      </p>
    </div>
  );
}
